import { navigateToParentRoute } from "./actions";

export { navigateToParentRoute as goToParent };
